import React from 'react';

import {
  IconButton,
  InputAdornment,
  TextField as MTextField,
} from '@mui/material';
import Clear from '@mui/icons-material/Clear';
import { observer } from 'mobx-react';

type ProjectsSearchProps = {
  searchText: string;
  setSearchText: (text: string) => void;
};

export const ProjectsSearch = observer(
  ({ searchText, setSearchText }: ProjectsSearchProps) => {
    const clearButton = searchText && (
      <InputAdornment position='end'>
        <IconButton
          aria-label='clear filter'
          onClick={() => {
            setSearchText('');
          }}
          edge='end'
          size='small'
        >
          <Clear fontSize='small' />
        </IconButton>
      </InputAdornment>
    );

    return (
      <MTextField
        size='small'
        label='Search projects'
        variant='outlined'
        value={searchText}
        sx={{ marginTop: '24px' }}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setSearchText(event.target.value);
        }}
        InputProps={{
          endAdornment: clearButton,
        }}
        fullWidth
      />
    );
  },
);
